'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _BrowserUnsupportedFullScreenWarning = require('./BrowserUnsupportedFullScreenWarning');

var _BrowserUnsupportedFullScreenWarning2 = _interopRequireDefault(_BrowserUnsupportedFullScreenWarning);

var _BrowserCookieFullScreenWarning = require('./BrowserCookieFullScreenWarning');

var _BrowserCookieFullScreenWarning2 = _interopRequireDefault(_BrowserCookieFullScreenWarning);

var _browserDetectionService = require('./browserDetectionService');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BrowserWarning = function BrowserWarning(props) {
    var supportedBrowser = props.supportedBrowser,
        features = props.features,
        acknowledgement = props.acknowledgement;


    var showBrowserWarning = (!supportedBrowser || !features.isSupported) && !acknowledgement;

    if (!showBrowserWarning) return null;

    if (!features.isSupported && features.errors.indexOf(_browserDetectionService.LOCAL_STORAGE_FEATURE_NAME) !== -1) {
        return _react2.default.createElement(_BrowserCookieFullScreenWarning2.default, props);
    }

    return _react2.default.createElement(_BrowserUnsupportedFullScreenWarning2.default, props);
};

// Constants


// Components
// Lib


BrowserWarning.propTypes = {
    supportedBrowser: _propTypes2.default.bool,
    features: _propTypes2.default.object,
    acknowledgement: _propTypes2.default.bool,
    acknowledgeUnsupportedBrowser: _propTypes2.default.func.isRequired
};

exports.default = BrowserWarning;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/error/browserSupport/BrowserWarning.js
// module id = 1762
// module chunks = 0